/**
 * ChartSkeleton - Loading skeleton for chart components.
 */
import { Skeleton } from '@/components/ui/skeleton'
import { chartDefaults } from './chartConfig'

export interface ChartSkeletonProps {
  /** Height of the skeleton in pixels */
  height?: number
  /** Type of chart skeleton to show */
  variant?: 'bar' | 'line' | 'pie'
}

/**
 * Animated loading skeleton for chart placeholders.
 */
export function ChartSkeleton({
  height = chartDefaults.height,
  variant = 'bar',
}: ChartSkeletonProps) {
  return (
    <div 
      data-testid="chart-skeleton"
      className="w-full animate-pulse"
      style={{ height }}
    >
      {variant === 'pie' ? (
        <div className="flex items-center justify-center h-full">
          <Skeleton className="h-48 w-48 rounded-full" />
        </div>
      ) : variant === 'line' ? (
        <div className="flex flex-col justify-end h-full gap-2 pt-4">
          <Skeleton className="h-1/3 w-full rounded" />
          <Skeleton className="h-1/4 w-full rounded" />
          <Skeleton className="h-4 w-full rounded mt-2" />
        </div>
      ) : (
        <div className="flex items-end justify-around h-full gap-2 pt-4 pb-6">
          {[65, 85, 45, 90, 55, 75, 60].map((h, i) => (
            <Skeleton 
              key={i} 
              className="flex-1 rounded-t" 
              style={{ height: `${h}%` }} 
            />
          ))}
        </div>
      )}
    </div>
  )
}
